import { createSelector } from 'reselect';

const selectRelatoriosState = (state) => state.relatorios;

export const makeSelectRelatoriosByIdProcessoAndIdUnidadeGerencia = (
    idProcesso,
    idUnidadeGerencia) =>
    createSelector(
        [selectRelatoriosState],
        (relatorios) => {
            const key = `${idProcesso}-${idUnidadeGerencia}`;
            return relatorios[key] || [];
        });
